module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/icon_info-o-1f07abf10b95224dff3484cdd61803f7.svg";